module.exports = __webpack_public_path__ + "img/element2.16b43963.svg";